<main [@fadeInOut] id="main-heading" role="main" tabindex="0">
  <div class="container-fluid padding-bottom-small bottom-padding">
    <div class="col-sm-11 center-block">
      <h1 tabindex="0" aria-label="Upload File - Cosmetic SPL Builder" role="heading" aria-level="1">Upload File - Cosmetic SPL Builder</h1>
      <div class="row">
        <div class="col-md-12">
          <app-file-upload [iconClassName]="'fa-file-excel'" [formatDisplayText]="'Excel (.xlsx) format only'"
            [allowExtensions]="'.xlsx'" [saveUrl]="uploadSaveUrl" (uploading)="onFileUploadStart($event)"
            (success)="onFileUploadedSuccess($event)" (failure)="onUploadFailure($event)">
          </app-file-upload>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div id="validation-result">
            <div class="validation-info">
              <h3 tabindex="0" aria-label="File Name" role="heading" aria-level="3">File Name:</h3>
              <span tabindex="0" aria-label="Validation file name">{{validationFileName}}</span>
            </div>
            <div class="validation-info">
              <h3 tabindex="0" aria-label="File Status" role="heading" aria-level="3">File Status:</h3>
              <span tabindex="0" aria-label="Validation upload status">{{uploadStatus}}</span>
            </div>
            <div class="validation-info">
              <h3 tabindex="0" aria-label="Pragmatic Validation Status" role="heading" aria-level="3">Pragmatic Validation Status:</h3>
              <span class="{{pragmaticValidationClass}}" tabindex="0" aria-label="Pragmatic Validation Status">{{pragmaticValidationResult}}</span>
            </div>

            <div class="validation-info d-none">
              <p>Your file was build successfully. Please download the file bellow. This will not be saved. Uploading a new template or refreshing the page will result in lost progress.</p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="cosmeticXml" class="row">
        <div class="col-md-12 actions mt-0">
          <div class="download-disclosure" tabindex="0" [attr.aria-label]="actionButtonText">
            {{ actionButtonText }}
          </div>
          <span>
            <button class="btn btn-primary" (click)="downloadCosmeticXml()"
                    tabindex="0" role="button" aria-label="Download Cosmetic File" (keydown.enter)="downloadCosmeticXml()">
              <div class="row">
                <div class="col-sm-1">
                  <span><i class="fas fa-download"></i></span>
                </div>
                <div class="col-sm-9 text-center" tabindex="0" aria-label="Download Cosmetic File">Download Cosmetic File</div>
                <div class="col-sm-2"></div>
              </div>
            </button>
          </span>
          <span>
            <button *ngIf="pragmaticResponseFile && cosmetic.pragmaticValidationResult != 3" class="btn btn-outline-primary" (click)="downloadPragmaticResponseFile()"
                    tabindex="0" role="button" aria-label="Download Cosmetic File" (keydown.enter)="downloadPragmaticResponseFile()">
              <div class="row">
                <div class="col-sm-1">
                  <span><i class="fas fa-circle-parking"></i></span>
                </div>
                <div class="col-sm-11 p-0" tabindex="0" aria-label="Download Cosmetic File">Download Pragmatic Validation Results</div>
              </div>
            </button>
          </span>

        </div>
      </div>
    </div>

    <div *ngIf="loading">
      <div id="loading"></div>
    </div>
  </div>
</main>
